import Shepherd from "shepherd.js";

export default {
    INIT_TOUR(state, {options, steps}) {
        state.instance = new Shepherd.Tour(options)
        state.instance.on('cancel', async () => {
            options.when?.cancel()
        });
        for (let step of steps) {
            for(let button of step?.buttons ?? []){
                if(button.actionName?.length){
                    button.action = state.instance[button.actionName]
                }
            }
            state.instance.addStep(step)
        }
    },
    START_TOUR(state) {
        state.instance.start()
    },
    CANCEL_TOUR(state) {
        state.instance?.cancel()
    }
}